<div class="ui-g">
    <div class="ui-sm-12 ui-md-9 ui-md-offset-1 ui-lg-6 ui-lg-offset-3 ui-xl-4 ui-xl-offset-4">
        <app-authorization></app-authorization>
    </div>
</div>